// shopConstants.js
'use strict';

export const SHOP_ID = {
  addvalue: 'addvalue',
  topup: 'top-up',
  messagePack: 'messagePack',
  subscription: 'subscription',
};

export const orderStatusConstant = {
  PENDING: 'pending',
  SUCCEEDED: 'succeeded',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
};

export const orderStatusWhiteList = [
  orderStatusConstant.PENDING,
  orderStatusConstant.SUCCEEDED,
  orderStatusConstant.CANCELLED,
  orderStatusConstant.FAILED,
];

export const PaymentMethodUsage = {
  SUBSCRIPTION: 'subscription',
  TOP_UP: 'top-up',
  ALL: 'all',
};

export const PaymentGateway = {
  SECURIONPAY: 'securionpay',
  TAPPAY: 'tappay',
  ECPAY: 'ecpay',
  CENTROBILL: 'centrobill',
  NINEONE_APP: 'nineoneapp',
};

export const ProductType = {
  DIAMONDS: 'diamonds',
  SUBSCRIPTIONS: 'subscriptions',
  MESSAGEPACKS: 'messagepacks',
  PASSES: 'passes_v2',
};

export const ProductPassType = {
  LIVESTREAM_PASS: 'livestream_pass',
  STORY_FEED_PASS: 'story_feed_pass',
  FLIX_FEED_PASS: 'flix_feed_pass',
};

export const SHOP_ROOT = 'shop-root';

export const InternalCurrency = {
  DIAMONDS: 'DIAMONDS',
};

export const OrderStatus = {
  BOUGHT: 'bought',
};

export const ServerOrderStatus = {
  PAID: 'paid',
  FULFILLED: 'fulfilled',
  REFUNDED: 'refunded',
};

export const PASSES_PRODUCT_QUANTITY = 1;

export const ProductNoticeClickAction = {
  CHECKOUT: 'checkout',
  USER_LEVEL_BENEFIT: 'user-level-benefit',
  SOLD_OUT: 'sold-out',
};

export const PaymentSourceType = {
  CARD: 'card',
};

export const FAKE_LAST4 = '****';

export const ShopSectionType = {
  AD: 'ad',
  ANCHOR: 'anchor',
  SECTION: 'section',
};

export const CurrencyToCountryMap = {
  EUR: 'eu',
  USD: 'us',
};
